<div>
    <div class="loading-text">
        <h1>{{ loadingText }}</h1>
    </div>
    <div class="loading-img">
        <img src="../../assets/spinner.svg">
    </div>
</div>